import { render, staticRenderFns } from "./TheServices.vue?vue&type=template&id=4a0ff874&scoped=true"
import script from "./TheServices.vue?vue&type=script&lang=js"
export * from "./TheServices.vue?vue&type=script&lang=js"
import style0 from "./TheServices.vue?vue&type=style&index=0&id=4a0ff874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ff874",
  null
  
)

export default component.exports